import React from 'react';
import { SEOBlock } from '../../common/components';
import { MainScreen } from './main-screen';
import { Advantages } from './advantages';
import { PopularCategories } from './popular-categories';
import { Catalogue } from './catalogue';

export const CatalogueLayout = () => (
	<div className="services-landings__content">
		<MainScreen
			title={'Установка товаров Лемана ПРО и\u00A0ремонтные работы'}
			basePhotoUrl={`/PKpalwvxsEWcT4KQ-614yQ/services-platform-landing-main-photo`}
			additionalText={
				'При покупке товаров Лемана\u00A0ПРО вы можете сразу заказать установку от\u00A0профессиональных и\u00A0проверенных мастеров'
			}
		/>
		<Advantages />
		<PopularCategories />
		<Catalogue />
		<SEOBlock />
	</div>
);
